import React, { useEffect, useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import VideoCard from "../../../components/Settings/academy/VideoCard";
import { useLocation } from "react-router-dom";
import useAcademy from "../../../hooks/useAcademy";
import Loading from "../../../components/animation/loading";
import VideoModal from "../../../components/Settings/academy/modal/VideoModal";

export default function Videos() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const { module } = location.state || {};
  const [trainingVideos, setTrainingVideos] = useState(null);
  const trainingModuleId = queryParams.get("trainingModuleId");
  const [triggerFetchVideo, setTriggerFetchVideo] = useState(0);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const { getTrainingVideos } = useAcademy();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await getTrainingVideos(setLoading, trainingModuleId);
        setTrainingVideos(data);
      } catch (error) {
        setLoading(false);
      }
      setLoading(false);
    };

    fetchData();
  }, [triggerFetchVideo]);

  return (
    <>
      <div className="flex flex-col space-y-10">
        <div className="flex flex-col space-y-6">
          <div className="flex justify-between">
            <div className="flex space-x-3 items-center">
              <KeyboardBackspaceIcon
                onClick={() => window.history.back()}
                className="cursor-pointer"
              />
              <h5 className="text-black">{module?.title}</h5>
              <BorderColorIcon fontSize="small" className="cursor-pointer " />
            </div>

            <button
              onClick={() => setOpenVideoModal(true)}
              className="bg-theme1 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Add Video
            </button>
          </div>
          <p className="text-[#2E2E32]">{module?.description}</p>
        </div>
        {loading ? (
          <div className="flex justify-center items-center">
            <Loading />
          </div>
        ) : trainingVideos?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {trainingVideos?.map((video) => (
              <VideoCard
                key={video.id}
                video={video}
                trainingVideos={trainingVideos}
                trainingModuleId={trainingModuleId}
                onTrigger={() => setTriggerFetchVideo((t) => t + 1)}
              />
            ))}
          </div>
        ) : (
          <div className="flex justify-center">
            No videos found in this module
          </div>
        )}
      </div>

      {openVideoModal && (
        <VideoModal
          key={trainingModuleId}
          trainingModuleId={trainingModuleId}
          setOpenVideoModal={setOpenVideoModal}
          onTrigger={() => setTriggerFetchVideo((t) => t + 1)}
        />
      )}
    </>
  );
}
